import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Header from "./components/Header.js";
import HomePage from "./pages/HomePage.js";
import KidsPage from "./pages/KidsPage.js";
import TeamsPage from "./pages/TeamsPage.js";
import NewsPage from "./pages/NewsPage.js";
import MenPage from "./pages/MenPage.js";
import WomenPage from "./pages/WomenPage.js";
import SearchResults from "./components/SearchResults.js";
import NewsArticlePage from "./pages/NewsArticlePage.js";
import CategoryPage from "./pages/CategoryPage.js";
import CookieConsent from "./components/CookieConsent.js";
import { Analytics } from "@vercel/analytics/react";
import EditArticlePage from "./pages/EditArticlePage.js";
import Login from "./components/Login.js"; // Import the login page
import UserArticlesPage from "./pages/UserArticlesPage.js";
import ManageCategoriesPage from "./pages/ManageCategoriesPage.js"; // Import Manage Categories Page
import ManageClassroomsPage from "./pages/ManageClassroomsPage.js"; // Import Manage Classrooms Page
import ClassroomDashboardPage from "./pages/ClassroomDashboardPage.js";
import ManageStudentsPage from "./pages/ManageStudentsPage.js"; // Import Manage Students Page
import StudentSubscriptionForm from "./components/StudentSubscriptionForm.js"; // ** Import Student Subscription Form **
import StudentProfilePage from "./pages/StudentProfilePage.js"; // ** Import Student Profile Page **
import ClassroomInviteLanding from "./pages/ClassroomInviteLanding.js";


import { useAuth, AuthProvider } from "./components/AuthProvider.js"; // Import Auth context
import TeacherSubscriptionForm from "./components/TeacherSubscriptionForm.js";
import CreateTestPage from "./pages/CreateTestPage.js";
import ENEMTrainingPage from "./pages/ENEMTrainingPage.js";
import DemoLandingPage from "./pages/DemoLandingPage.js";
import DemoEditArticlePage from "./pages/DemoEditArticlePage.js";
import DemoENEMTrainingPage from "./pages/DemoENEMTrainingPage.js";
import EssayResultPage from "./pages/EssayResultPage.js";
import TestPixPaymentPage from "./pages/TestPixPaymentPage.js";

// Protected route component
const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    // If the user is not authenticated, redirect to the login page
    return <Navigate to="/login" />;
  }

  // If the user is authenticated, render the requested page
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<ENEMTrainingPage />} />
          <Route path="/kids" element={<KidsPage />} />
          <Route path="/teams" element={<TeamsPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/men" element={<MenPage />} />
          <Route path="/women" element={<WomenPage />} />
          <Route path="/search-results" element={<SearchResults />} />
          <Route path="/news/:id" element={<NewsArticlePage />} />
          <Route path="/category/:categoryName" element={<CategoryPage />} />

         {/* Protect the user articles route */}
         <Route
            path="/my-articles"
            element={
              <ProtectedRoute>
                <UserArticlesPage />
              </ProtectedRoute>
            }
          />

          {/* Protected route for editing articles */}
          <Route
            path="/articles/edit/:id"
            element={
              <ProtectedRoute>
                <EditArticlePage />
              </ProtectedRoute>
            }
          />

          {/* Route for creating a new article */}
          <Route
            path="/articles/create"
            element={
              <ProtectedRoute>
                <EditArticlePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/tests/create"
            element={
              <ProtectedRoute>
                <CreateTestPage />
              </ProtectedRoute>
            }
          />

          {/* Login route */}
          <Route path="/login" element={<Login />} />

          {/* ** Student Subscription Route ** */}
          <Route path="/subscribe/student" element={<StudentSubscriptionForm />} />

          {/* ** Protected Student Profile Route ** */}
          <Route
            path="/student-profile"
            element={
              <ProtectedRoute>
                <StudentProfilePage />
              </ProtectedRoute>
            }
           />

          {/* Management Routes (Protected) */}
          <Route
            path="/manage/categories"
            element={
              <ProtectedRoute>
                <ManageCategoriesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manage/classrooms"
            element={
              <ProtectedRoute>
                <ManageClassroomsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manage/classrooms/:classroomId"
            element={
              <ProtectedRoute>
                <ClassroomDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscribe/teacher"
            element={
              <TeacherSubscriptionForm />
            }
          />

           <Route
            path="/manage/students"
            element={
              <ProtectedRoute>
                <ManageStudentsPage />
              </ProtectedRoute>
            }
          />

          {/* ENEM Training Route (Protected - Students only) */}
          <Route
            path="/enem-training"
            element={
              
              <ENEMTrainingPage />
              
            }
          />
        <Route path="/enem-training/essay/:id" element={<EssayResultPage />} />

          {/* Demo Routes - No authentication required */}
          <Route path="/demo" element={<DemoLandingPage />} />
          <Route path="/demo/article-writer" element={<DemoEditArticlePage />} />
          <Route path="/demo/enem-training" element={<DemoENEMTrainingPage />} />
          
          {/* Test PIX Payment Route */}
          <Route path="/test-pix" element={<TestPixPaymentPage />} />

          <Route path="/classrooms/:inviteId/join" element={<ClassroomInviteLanding />} />

          <Route path="*" element={<Navigate to="/enem-training" replace />} />

        </Routes>
        <CookieConsent />
        <Analytics />
      </Router>
    </AuthProvider>
  );
}

export default App;
